import { gql, useMutation } from '@apollo/client';
import { Pda } from './components/Pda';
import { Header } from './components/Header';
import { ArrivalRelatedScanComponent, HandleScanEventResult } from './components/ArrivalRelatedScanComponent';
import { isTrackingNumber, showTrackingNumberError } from '../../utils/BarCodeUtil';
import { playScanSound } from '../../utils/scanUtils';
import { Toast } from 'antd-mobile';
import React, { useState } from 'react';
import {NextActionOverlay} from "./components/NextActionOverlay";
import { t } from '../../i18n';

// GraphQL Mutation for Holding Scan
const HANDLE_HOLDING_SCAN_EVENT = gql`
   mutation HandleHoldingScanEvent($barCode: String!) {
     result: handleHoldingScanEvent(barCode: $barCode) {
       success
       nextAction
     }
   }
`;

const PageBody = () => {
    const [handleHoldingScanEvent] = useMutation(HANDLE_HOLDING_SCAN_EVENT);
    const [overlayVisible, setOverlayVisible] = useState(false);
    const [overlayData, setOverlayData] = useState<{
        nextAction: string;
        trackingNumber: string;
    } | null>(null);

    const handleScanEvent = async (barCode: string): Promise<HandleScanEventResult> => {
        if (!isTrackingNumber(barCode)) {
            showTrackingNumberError(barCode);
            return { success: false };
        }
        const { data } = await handleHoldingScanEvent({ variables: { barCode } });
        const result = data?.result;

        // nextAction 优先提示
        if (result?.nextAction) {
            await playScanSound();
            setOverlayData({
                nextAction: result.nextAction,
                trackingNumber: barCode
            });
            setOverlayVisible(true);
            return { success: !!result.success};
        }

        if (!result?.success) {
            Toast.show({ content: `${t('pda.common.scanFailed')}: ${t('pda.common.noNextAction')}` });
            return { success: false };
        }

        return { success: true };
    };

    const handleOverlayClose = () => {
        setOverlayVisible(false);
        setOverlayData(null);
    };

    return (
        <>
            <ArrivalRelatedScanComponent
                value1Placeholder={t('pda.pages.holding.trackingNO')}
                value1ColumnTitle={t('pda.pages.holding.trackingNO')}
                handleScanEvent={handleScanEvent}
            />
            {overlayData && (
                <NextActionOverlay
                    visible={overlayVisible}
                    nextAction={overlayData.nextAction}
                    trackingNumber={overlayData.trackingNumber}
                    onClose={handleOverlayClose}
                />
            )}
        </>
    );
};

export default function HoldingPage() {
    return (
        <div className="w-full h-full flex flex-col gap-2 p-2">
            <Header title={t('pda.pages.holding.holdingScan')} />
            <Pda/>
            <PageBody/>
        </div>
    );
} 